import { useQuery } from "@apollo/client/react";
import { queries } from "@/graphql";
import { getPartnerKey } from "@/utils";

/**
 * Custom hook to check whether registration/sign-up is allowed for the current partner.
 * Identifies partner by URL via getPartnerKey(), queries partnerSettings with fallback to global settings.
 */
export function useAllowRegistration() {
  const partnerKey = getPartnerKey();

  const { data, loading, error, refetch } = useQuery<{
    partnerSettings: any;
  }>(queries.partnerSettings, {
    variables: {
      partnerKey,
      key: "allow-registration",
      fallback: true,
    },
    errorPolicy: "all",
    fetchPolicy: "cache-and-network",
  });

  let raw = data?.partnerSettings;

  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (typeof parsed === "boolean" || typeof parsed === "string") {
        raw = parsed;
      }
    } catch {
      // raw is unquoted string
    }
  }

  let allowRegistration = false;
  if (typeof raw === "boolean") {
    allowRegistration = raw;
  } else if (typeof raw === "string") {
    allowRegistration = raw.trim().toLowerCase() === "yes";
  }

  return {
    allowRegistration,
    loading,
    error,
    refetch,
    partnerKey,
  };
}
